import React, { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "../Style/Ourteam.css";

import frame1 from "../assets/bobble1 (1).png";
import frame2 from "../assets/bobble1 (2).png";
import frame3 from "../assets/bobble1 (3).png";
import frame4 from "../assets/bobble1 (4).png";
import frame5 from "../assets/bobble1 (5).png";

const FRAMES = [frame1, frame2, frame3, frame4, frame5];
const FRAME_INTERVAL_MS = 200;

const OurTeam = () => {
  const [frameIndex, setFrameIndex] = useState(0);
  const stageRef = useRef(null);

  // React Router navigation
  const navigate = useNavigate();

  useEffect(() => {
    const id = setInterval(() => {
      setFrameIndex((prev) => (prev + 1) % FRAMES.length);
    }, FRAME_INTERVAL_MS);

    return () => clearInterval(id);
  }, []);

  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);

  const springRotateX = useSpring(rotateX, {
    stiffness: 150,
    damping: 15,
  });

  const springRotateY = useSpring(rotateY, {
    stiffness: 150,
    damping: 15,
  });

  const handleMouseMove = (e) => {
    const stage = stageRef.current;

    if (!stage) return;

    const bounds = stage.getBoundingClientRect();

    const px =
      (e.clientX - bounds.left) / bounds.width - 0.5;

    const py =
      (e.clientY - bounds.top) / bounds.height - 0.5;

    rotateY.set(px * 12);
    rotateX.set(py * -12);
  };

  const handleMouseLeave = () => {
    rotateX.set(0);
    rotateY.set(0);
  };

  // Navigate to Team page
  const handleTeamClick = () => {
    navigate("/team-page");
  };

  return (
    <section className="our-team">

      {/* TOP SECTION */}
      <div className="our-team__top">

        {/* ANIMATED TEAM IMAGE */}
        <div className="our-team__stage-wrap">

          <div
            className="our-team__glow"
            aria-hidden="true"
          />

          <motion.div
            className="our-team__stage"
            ref={stageRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
              rotateX: springRotateX,
              rotateY: springRotateY,
            }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            animate={{
              y: [0, -10, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <img
              src={FRAMES[frameIndex]}
              alt="MPeoples team"
              className="our-team__frame"
            />
          </motion.div>

          <div
            className="our-team__platform"
            aria-hidden="true"
          />

        </div>

        {/* TEXT */}
        <div className="our-team__intro">

          <span className="our-team__eyebrow">
            Meet Our Team
          </span>

          <h2 className="our-team__heading">
            Meet the Experts Behind MPeoples.
          </h2>

          <p className="our-team__description">
            Behind every successful project is a passionate team of
            designers, software developers, UI/UX specialists, digital
            marketers, QA engineers, and project managers dedicated to
            building exceptional digital experiences. We combine creativity,
            technical expertise, and business strategy to deliver innovative
            technology solutions that help businesses thrive.
          </p>

          <button
            type="button"
            className="our-team__cta"
            onClick={handleTeamClick}
          >
            Meet Our Team
          </button>

        </div>

      </div>

      {/* CLOSING TEXT */}
      <div className="our-team__closing">
        <p>
          Partner with a passionate team committed to building digital
          solutions that help your business innovate, grow, and lead in
          today&apos;s competitive digital world.
        </p>
      </div>

    </section>
  );
};

export default OurTeam;